<template>
  <div id="app" class="application">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      calc: false,
      input: 0,
      mql: null,
      currentPage: 0,
      scrollLeft: 0,
    }
  },
  computed: {
    output() {
      return this.input === 0 ? 0 : Math.round(this.input / 640 * 375);
    }
  },
  methods: {
    handleScroll(value) {
      this.scrollLeft = value;
    },
  },
  mounted() {
    // document.body.addEventListener('touchmove', function(evt) {
    //   if(!evt._isScroller){
    //     evt.preventDefault();
    //   }
    // });
  }
}
</script>

<style lang="scss">
.application{
}
</style>
